import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import {useEffect, useState } from 'react'

const Portfolio = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

/*
    const [iframeVisible, setIframeVisible] = useState(false);

    const toggleIframe = () => { 
      setIframeVisible(!iframeVisible);
    };
    
    
    const closeIframe = () => {
      setIframeVisible(false);
    };
  

    const [iframeVisibleML, setIframeVisibleML] = useState(false);

    const toggleIframeML = () => { 
      setIframeVisibleML(!iframeVisibleML);
    };
    
    
    const closeIframeML = () => {
      setIframeVisibleML(false);
    };




    const [iframeVisibleAnalytics, setIframeVisibleAnalytics] = useState(false);

    const toggleIframeAnalytics = () => { 
      setIframeVisibleAnalytics(!iframeVisibleAnalytics);
    };
    
    
    const closeIframeAnalytics = () => {
      setIframeVisibleAnalytics(false);
    };
*/

    useEffect(() => {
        setTimeout(() => {
          setLetterClass('text-animate-hover')
        }, 3000)
      }, [])


    return (
        <div className='container portfolio-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters 
                    letterClass={letterClass}
                    strArray={['P','r','o','d','u','c','t','s']}
                    idx={15}
                    />
                </h1>
                <p>
                Welcome to the world of Triple Point Analytics
                Where no project is too big or small. simple or complex
                We have a solution for you
                </p>

                <h2>
                    Core Capabilities      
                </h2>
                <p>
                    Machine Learning = [Traditional Machine Learning or Deep Neural Networks] <br/>
                    Clients = Bubbly.ai, Enforce.ai, Capture.ai <br/><br/>
                    Data Engineering = [Data Engineering, Cloud or On-Prem] <br/>
                    Clients = Anyar Inc, MTSI, GPI <br/><br/>
                    Data Analytics = [Custom dashboarding solutions] <br/>
                    Clients = SRI, AKS, UDFS <br/>

                </p>

            </div>


      
       
       
       
       
        </div>
    )
}

export default Portfolio
